import { FC } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { Switch } from '../../../../components/switch/index';
import {
  SharedCapTableSettings,
  SharedCapTableViewOptions,
} from '../../../../hooks/shared-cap-table/shared-cap-table.types';
import { StringKey } from '../../../../lang/index';

type ViewOptionsTabProps = {
  onSettingsChange: (settings: SharedCapTableSettings) => void;
  settings: SharedCapTableSettings;
};

const VIEW_OPTION_TITLES: [keyof SharedCapTableViewOptions, StringKey][] = [
  ['hideOverallStatus', 'SHARE_HIDE_OVERALL_STATUS'],
  ['hideOwnershipChart', 'SHARE_HIDE_OWNERSHIP_CHART'],
  ['hideStakeholderNames', 'SHARE_HIDE_STAKEHOLDER_NAMES'],
];

/** A card per option with the same rhythm as the Privacy tab: one shared card ran them together. */
export const ViewOptionsTab: FC<ViewOptionsTabProps> = ({ onSettingsChange, settings }) => (
  <div className="flex flex-col gap-2">
    {VIEW_OPTION_TITLES.map(([optionKey, title]) => (
      <div
        className="flex h-[52px] items-center justify-between gap-4 rounded-lg bg-gray-50 px-4"
        key={optionKey}
      >
        <span className="text-sm font-[450] text-gray-700">
          <AppFormattedMessage id={title} />
        </span>
        <Switch
          checked={settings.viewOptions[optionKey]}
          onChange={(state) =>
            onSettingsChange({
              ...settings,
              viewOptions: { ...settings.viewOptions, [optionKey]: state },
            })
          }
        />
      </div>
    ))}
  </div>
);
